<template>
  <div id="app">
  
    <Index></Index>
  </div>
</template>

<script>
import Index from "@/views/index";
import '@/assets/css/base.css';
Array.prototype.remove = function(value){
  var len = this.length;
  for (var i = 0,n = 0; i < len; i++) {
    if(this[i]!=value){
      this[n++] = this[i];
    }
  }
  this.length = n;
}
export default {
  name: 'App',
  provide(){
      return {
        
      }
  },
  data () {
    return {
      
    }
  },
  components: {
    Index
  },
  methods: {
   
  },
  mounted () {
    console.log(this.$route.meta.keepAlive);
    
  }
}
</script>

<style>
.mui-toast-container {
              bottom: 20% !important;			
        }
        #tcBtn{
          text-size-adjust: none;
          right: 35px !important;
          top: 350px !important;
          width: 110px !important;
          height: 110px !important;
          border-radius: 45px;
          /* background: #fff; */
          text-align: center;
          box-shadow: 0 1px 3px rgba(0,0,0,.2);
        }
        .maplibTcBtn_mobile{
          background: url(../static/images/traffic_bl.png) rgba(255,255,255,0.8) no-repeat scroll center center !important;
          background-size:80% !important;
        }
        .maplibTcBtnOff_mobile{
          background: url(../static/images/traffic_no.png) rgba(255,255,255,0.8) no-repeat scroll center center !important;
          background-size:80% !important;
        }
        #tcWrap{
          display: none !important;
        }
        .tangram-suggestion-main{
          z-index: 1000 !important;
        }
        .anchorBL{
          display: none !important;
        } 
.weui-cell {
  padding: 20px;
}
p.weui-media-box__desc {
  font-size:25px;
}
#map {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 750px;
  margin: 0 auto;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue